export const asyncRouterMap = [
  {
    name: '404',
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap_P = [

  {
    name: 'login',
    path: '/pc_login',
    component: () => import('../src/views/PC/Login.vue'),
  },
]
export const constantRouterMap_M = [
  {
    name: 'login',
    path: '/m_login',
    component: () => import('../src/views/Mobile/Login.vue'),
  },
]


//////////////////
// WEBPACK FOOTER
// ./config/router.config.js
// module id = 0nep
// module chunks = 46